import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

interface AuthCallbackProps {
  setLoggedIn?: (loggedIn: boolean) => void;
}

const AuthCallback: React.FC<AuthCallbackProps> = ({ setLoggedIn }) => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const refreshToken = params.get('refreshToken');

    if (token && refreshToken) {
      // Store tokens
      localStorage.setItem('accessToken', token);
      localStorage.setItem('refreshToken', refreshToken);

      // Update logged in state
      if (setLoggedIn) {
        setLoggedIn(true);
      }

      // Redirect to profile
      history.push('/profile');
    } else {
      // Error - redirect to login
      history.push('/login?error=auth_failed');
    }
  }, [location, history, setLoggedIn]);

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h2>Completing sign in...</h2>
    </div>
  );
};

export default AuthCallback;
